import { type WithingsOrderPostContentObjectDetail, createWithingsOrderPostContentObjectDetail } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getOrderPost } from '../../services';
import { getContentObjectDetailQueryKey } from '../keys';

export const useOrderPostQuery = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<WithingsOrderPostContentObjectDetail, ApiClientResponseError<ResponseErrorDataObject>>,
    'queryFn' | 'queryKey'
  >,
) =>
  useQuery<WithingsOrderPostContentObjectDetail>({
    async queryFn() {
      const { data } = await getOrderPost({ routeParams: { id } });
      return createWithingsOrderPostContentObjectDetail(data);
    },
    queryKey: getContentObjectDetailQueryKey({ id }),
    ...queryOptions,
  });
